import React, { useState, useEffect } from 'react';
import Header from '../Components/Header';
import Footer from '../Components/Footer';
import RandomContent from '../Components/RandomContent';
import { convertCurrency } from '../Conversion/Convertors';
import { GetPageContentBySlug } from '../services/apiservice';
import { useLocation } from "react-router-dom";

const CurrencyConvertor = () => {
  const [amount, setAmount] = useState('');
  const [fromCurrency, setFromCurrency] = useState('USD');
  const [toCurrency, setToCurrency] = useState('EUR');
  const [convertedAmount, setConvertedAmount] = useState('');
  const [isError, setIsError] = useState(false);
  const [pageContent, setpageContent] = useState('');

  const currencies = ['USD', 'EUR', 'INR', 'GBP', 'JPY'];

  const location = useLocation();
  const paramlink = location.pathname.split("/").filter(Boolean).pop();

  useEffect(() => {
    setAmount('');
    setConvertedAmount('');
    setIsError(false);
    GetPageContent();
  }, []);

  const GetPageContent = async () => {
    if (paramlink !== undefined && paramlink !== "") {
      try {
        const postMetaList = await GetPageContentBySlug(paramlink);
        const jsonMetaList = JSON.parse(postMetaList);
        setpageContent(jsonMetaList);
      } catch (error) {
        console.error('Error fetching the meta data:', error);
      }
    }
  };

  const handleConversion = () => {
    const { convertedData, isError } = convertCurrency(amount, fromCurrency, toCurrency);
    setConvertedAmount(convertedData);
    setIsError(isError);
  };

  const handleSwap = () => {
    const temp = fromCurrency;
    setFromCurrency(toCurrency);
    setToCurrency(temp);
  };

  return (
    <>
      <Header />


      <RandomContent />

      {/* Page Intro */}
      <div className="blog-area">
        <div className="container-block-fluid">
          <div className="row justify-content-center">
            <div className="full-col col-lg-12 col-md-12">
              <div
                className="single-blog-inner"
                data-aos="fade-up"
                data-aos-duration="2800"
              >
                <div className="details">
                  <h4>
                    <a href="#">{pageContent?.section1header}</a>
                  </h4>
                  <div
                    dangerouslySetInnerHTML={{
                      __html:
                        pageContent?.section1text &&
                          pageContent.section1text.trim() !== ""
                          ? pageContent.section1text
                          : `Quickly convert amounts between major currencies online! Enter
                    an amount, choose the source and target currencies, and get
                    instant results. Works offline with preset rates. 🚀`,
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Conversion Section */}
      <div className="blog-area pb-20">
        <div className="container-block-fluid">
          <div className="row justify-content-center">
            <div className="full-col col-lg-6 col-md-8">
              <div
                className="single-blog-inner p-5 shadow-sm rounded-lg"
                data-aos="fade-up"
                data-aos-duration="2800"
              >
                {/* Amount Input */}
                <div className="mb-4">
                  <label className="form-label">Amount</label>
                  <input
                    type="number"
                    className={`form-control ${isError ? 'is-invalid' : ''}`}
                    value={amount}
                    placeholder="Enter amount"
                    onChange={(e) => { setAmount(e.target.value); setIsError(false); }}
                  />
                  {isError && <div className="invalid-feedback">Please enter a valid amount</div>}
                </div>

                {/* Currency Selection */}
                <div className="d-flex justify-content-between align-items-center mb-4 gap-2 flex-wrap">
                  <div style={{ flex: 1 }}>
                    <label className="form-label">From</label>
                    <select
                      className="form-select"
                      value={fromCurrency}
                      onChange={(e) => setFromCurrency(e.target.value)}
                    >
                      {currencies.map(c => <option key={c} value={c}>{c}</option>)}
                    </select>
                  </div>

                  {/* Swap Button */}
                  <div style={{ flex: '0 0 40px', textAlign: 'center', fontSize: '24px', cursor: 'pointer' }} onClick={handleSwap}>
                    ↔
                  </div>

                  <div style={{ flex: 1 }}>
                    <label className="form-label">To</label>
                    <select
                      className="form-select"
                      value={toCurrency}
                      onChange={(e) => setToCurrency(e.target.value)}
                    >
                      {currencies.map(c => <option key={c} value={c}>{c}</option>)}
                    </select>
                  </div>
                </div>

                {/* Convert Button */}
                <button className="default-btn icon four w-100 mb-3" onClick={handleConversion}>
                  Convert
                </button>

                {/* Disclaimer */}
                <p style={{ fontSize: '0.78rem', color: '#888', textAlign: 'center', marginBottom: '12px' }}>
                  Rates are approximate and may not reflect current market values.
                </p>

                {/* Result */}
                {convertedAmount && (
                  <div className="result-box p-3 rounded shadow-sm text-center" style={{ backgroundColor: '#f5f5f5' }}>
                    <strong>{convertedAmount} {toCurrency}</strong>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Section 2 Below Boxes */}
      {pageContent?.section2text &&
        pageContent.section2text.trim() !== "" && (
          <div className="blog-area">
            <div className="container-block-fluid">
              <div className="row justify-content-center">
                <div className="full-col col-lg-12 col-md-12">
                  <div
                    className="single-blog-inner"
                    data-aos="fade-up"
                    data-aos-duration="2800"
                  >
                    <div className="details">
                      <div
                        dangerouslySetInnerHTML={{
                          __html: pageContent.section2text,
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

      {/* Section 3 Below Boxes */}
      {pageContent?.section3text &&
        pageContent.section3text.trim() !== "" && (
          <div className="blog-area">
            <div className="container-block-fluid">
              <div className="row justify-content-center">
                <div className="full-col col-lg-12 col-md-12">
                  <div
                    className="single-blog-inner"
                    data-aos="fade-up"
                    data-aos-duration="2800"
                  >
                    <div className="details">
                      <div
                        dangerouslySetInnerHTML={{
                          __html: pageContent.section3text,
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

      <Footer />

      <style jsx>{`
        .form-label {
          font-weight: 600;
          margin-bottom: 5px;
        }
        .result-box {
          font-size: 18px;
        }
        @media(max-width: 576px) {
          .d-flex {
            flex-direction: column !important;
          }
          .d-flex > div:nth-child(2) {
            margin: 10px 0;
          }
        }
      `}</style>
    </>
  );
};

export default CurrencyConvertor;
